import dayjs from "dayjs";
import localizedFormatPlugin from "dayjs/plugin/localizedFormat";
import advancedFormatPlugin from "dayjs/plugin/advancedFormat";
import timezonePlugin from "dayjs/plugin/timezone";
import utcPlugin from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/pt-br";

dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);

dayjs.extend(advancedFormatPlugin);
dayjs.extend(localizedFormatPlugin);
dayjs.extend(relativeTime);
dayjs.extend(updateLocale);

dayjs.locale("pt-br");
